<template>
  <div>
    <v-progress-circular v-show="saveLoading"
                         indeterminate
                         color="primary"
    ></v-progress-circular>

    <div  v-if="editedItem">
        <div  class="installment_product_wrapper">
            <div ref="wrapper" class="page page2">
                <div class="installment_product_header">
                    <table class="leftBox">
<!--                        <tr>-->
<!--                            <th width="100px">超優</th>-->
<!--                            <th width="100px">優加</th>-->
<!--                            <th width="58px">優質</th>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                            <td><span style="font-size: 20px;">{{editedItem.header.caseType5}}</span></td>-->
<!--                            <td><span style="font-size: 20px;">{{editedItem.header.caseType}}</span></td>-->
<!--                            <td><span style="font-size: 20px;">{{editedItem.header.caseType4}}</span></td>-->
<!--                        </tr>-->
<!--                      todo 9/23更新-->
                      <tr>
                        <th width="45px">專案</th>
                        <td width="45px">
                          <span v-if="editedItem.header.caseType5 !== ''">超優</span>
                          <span v-if="editedItem.header.caseType !== ''">優加</span>
                          <span v-if="editedItem.header.caseType4 !== ''">優質</span>
                        </td>
                        <th width="45px">客&nbsp;戶<br/>條&nbsp;件</th>
                        <td v-if="editedItem.header.caseType5 !== ''"><span style="font-size: 14px;" >{{editedItem.header.caseType5}}</span></td>
                        <td v-if="editedItem.header.caseType !== ''"><span style="font-size: 14px;" >{{editedItem.header.caseType}}</span></td>
                        <td v-if="editedItem.header.caseType4 !== ''"><span style="font-size: 14px; " >{{editedItem.header.caseType4}}</span></td>
                      </tr>
                    </table>
                    <h1>裕隆集團&nbsp;&nbsp;&nbsp;裕富數位資融股份有限公司<span class="h1s">2023.08&nbsp;通路版</span></h1>
                    <h2>購物分期付款申請暨約定書</h2>
                </div><!--header-->
                <div class="blueBox blueBox1">
                    <div class="tit">基本資料</div>
                    <div class="date">
                        申請日期：<span class="y">{{editedItem.applyDate.year}}</span>年<span class="m">{{editedItem.applyDate.month}}</span>月<span
                            class="d">{{editedItem.applyDate.day}}</span>日
                    </div>
                    <table class="blueTable blueTable1">
                        <tr>
                            <th width="45px">中&nbsp;文<br/>姓&nbsp;名</th>
                            <td width="113px">{{editedItem.customer.name}}</td>
                            <th width="48px">身分證<br/>字&nbsp;&nbsp;&nbsp;&nbsp;號</th>
                            <td>{{editedItem.customer.memberId}}</td>
                        </tr>
                        <tr>
                            <th>出&nbsp;生<br/>日&nbsp;期</th>
                            <td>
                                <!--<span>{{editedItem.customer.birthday}}</span>-->
                                <span class="y">{{editedItem.customer.birthdayInfo ? editedItem.customer.birthdayInfo.year : ''}}</span>年
                                <span class="m">{{editedItem.customer.birthdayInfo ? editedItem.customer.birthdayInfo.month :''}}</span>月
                                <span class="d">{{editedItem.customer.birthdayInfo ? editedItem.customer.birthdayInfo.day: ''}}</span>日
                            </td>
                            <th>婚&nbsp;姻<br/>狀&nbsp;況</th>
                            <td>
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    :checked="editedItem.customer.married[0].value === true"></span>已婚
                                </div>
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    :checked="editedItem.customer.married[1].value === true"></span>未婚
                                </div>
                                <br/>
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    :checked="editedItem.customer.hasChild"></span>子女<span
                                        class="nb">{{editedItem.customer.childCount}}</span>人
                                </div>
                            </td>
                        </tr>
                    </table><!--blueTable1-->
                    <table class="blueTable blueTable2">
                        <tr>
                            <th width="45px">身分證<br/>初補換</th>
                            <td width="163px">
                                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  :checked="editedItem.customer.memberIdType[0].value === true"></span>初發<br/><span
                                        class="checkbox"><input type="checkbox" disabled
                                                                :checked="editedItem.customer.memberIdType[1].value === true"></span>補發<br/><span
                                        class="checkbox"><input type="checkbox" disabled
                                                                :checked="editedItem.customer.memberIdType[2].value === true"></span>換發
                                </div>
                                <div class="date2">
                                    <span>{{editedItem.customer.memberIdDate}}</span>
                                    <!--<span class="y">106</span>年-->
                                    <!--<span class="m">12</span>月-->
                                    <!--<span class="d">30</span>日-->
                                </div>
                            </td>
                            <th width="48px">發&nbsp;證<br/>地&nbsp;點</th>
                            <td v-if="checkMemberIdCityNumberType">{{getMemberIdCity(editedItem.customer.memberIdCity)}}</td>
                            <td v-else>{{editedItem.customer.memberIdCity}}</td>
                        </tr>
                    </table><!--blueTable2-->
                    <table class="blueTable blueTable3">
                        <tr>
                            <th width="45px">戶&nbsp;籍<br/>電&nbsp;話</th>
                            <td width="115px" class="td-phone">
                                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.hasPhone"></span>無
                                </div>
                                {{editedItem.customer.phone}}
                            </td>
                            <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.hasHomePhone"></span>無
                                </div>
                                {{editedItem.customer.homePhone}}
                                <div v-if="editedItem.customer.isSecret"  :class="`btn-s btn-s1 ${editedItem.customer.isSecret ? 'btn-s-active':''}`">
                                    <a href="#" target="_self">保密</a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>行&nbsp;動<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.hasCellphone"></span>無
                                </div>
                                {{editedItem.customer.cellphone}}
                            </td>
                            <th>教&nbsp;育<br/>程&nbsp;度</th>
                            <td>
                                <div class="checkDiv checkDiv3">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.educationLevel[0].value"></span>博士
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.educationLevel[1].value"></span>碩士
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.educationLevel[2].value"></span>大學
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.educationLevel[3].value"></span>專科
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.educationLevel[4].value"></span>高中職
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.educationLevel[5].value"></span>其他
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>戶&nbsp;籍<br/>地&nbsp;址</th>
                            <td colspan="3">{{editedItem.customer.home.residencePost}}{{editedItem.customer.home.residenceCity}}{{editedItem.customer.home.residenceArea}}{{ editedItem.customer.home.residenceAddress}}</td>
                        </tr>
                        <tr>
                            <th>住&nbsp;宅<br/>地&nbsp;址</th>
                            <td colspan="3" class="td-address4">
                                <div class="checkDiv checkDiv4">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.home.homeType1[0].value"></span>同戶籍
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.home.homeType1[1].value"></span>另列如下
                                </div>
                              {{editedItem.customer.home.homePost}}{{editedItem.customer.home.homeCity}}{{editedItem.customer.home.homeArea}}{{editedItem.customer.home.homeAddress1}}
                            </td>
                        </tr>
                        <tr>
                            <th>居&nbsp;住<br/>時&nbsp;間</th>
                            <td>
                                <div class="date3">
                                    <span class="y">{{editedItem.customer.home.liveYear}}</span>年
                                    <span class="m">{{editedItem.customer.home.liveMonth}}</span>月
                                </div>
                            </td>
                            <th>居&nbsp;住<br/>狀&nbsp;況</th>
                            <td>
                                <div class="checkDiv checkDiv5">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.home.liveLevel[0].value"></span>本人名下
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.home.liveLevel[1].value"></span>配偶名下<br/>
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.home.liveLevel[2].value"></span>親友
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.home.liveLevel[3].value"></span>租賃
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.home.liveLevel[4].value"></span>宿舍
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.customer.home.liveLevel[5].value"></span>其他
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>繳&nbsp;款<br/>方&nbsp;式</th>
                            <td colspan="3" class="td-address6">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.customer.usePhonePayment"></span>簡訊條碼繳款
                                </div>
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.customer.useElectronicBill"></span>電子帳單(請填E-mail)
                                </div>
                                {{editedItem.customer.paymentEmail}}
                            </td>
                        </tr>
                        <tr>
                            <th>E-mail</th>
                            <td colspan="3" class="td-email">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.customer.hasMail"></span>無
                                </div>
                                {{editedItem.customer.email}}
                            </td>
                        </tr>
                    </table><!--blueTable3-->
                </div><!--blueBox1-->
                <div class="blueBox blueBox2">
                    <div class="tit">職業資料</div>
                    {{getCaseProduct(editedItem.vendor)}}
                    <div class="contact">
                        服務電話：(02)2702-5055#3<br/>
                        案件傳真：(02)2700-3559
                    </div>
                    <table class="blueTable blueTable4">
                        <tr>
                            <th width="48px">公&nbsp;司<br/>名&nbsp;稱</th>
                            <td width="135px" class="td-com">
                                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.company.type[0].value"></span>無<span
                                        class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.company.type[1].value"></span>家管<span
                                        class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.company.type[2].value"></span>另列如下
                                </div>
                                {{editedItem.company.name}}
                            </td>
                            <th width="48px">公&nbsp;司<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.company.hasPhone"></span>無
                                </div>
                               {{editedItem.company.areaCode}}{{editedItem.company.phone}}
                                <div v-if="editedItem.company.isSecret" :class="`btn-s btn-s2 ${editedItem.company.isSecret ? 'btn-s-active':''}`">
                                    <a href="#" target="_self">保密</a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>公&nbsp;司<br/>地&nbsp;址</th>
                            <td class="td-address" colspan="3">
                                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.company.hasAddress"></span>無
                                </div>
                              {{editedItem.company.address}}
                            </td>
                        </tr>
                    </table><!--blueTable4-->
                    <table class="blueTable blueTable5">
                        <tr>
                            <th width="48px">職稱</th>
                            <td width="90px">{{editedItem.company.title}}</td>
                            <th width="35px">年資</th>
                            <td width="73px">
                                <div class="date4">
                                    <span class="y">{{editedItem.company.workYear}}</span>年
                                    <span class="m">{{editedItem.company.workMonth}}</span>月
                                </div>
                            </td>
                            <th width="33px">月薪</th>
                            <td><span class="salary">{{editedItem.company.salary}}</span>元</td>
                        </tr>
                    </table><!--blueTable5-->
                    <div class="blueBox blueBox3">
                        <div class="tit">銀行資料</div>
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.bank.type[0].value"></span>沒辦過卡
                        </div>
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.bank.type[1].value"></span>無卡自停
                        </div>
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.bank.type[2].value"></span>協商繳款中
                        </div>
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.bank.type[3].value"></span>其他：
                            <div class="others">{{editedItem.bank.otherType}}</div>
                        </div>
                        <table class="blueTable blueTable6">
                            <tr>
                                <th width="48px">發&nbsp;卡<br/>銀&nbsp;行</th>
                                <td width="125px">{{editedItem.bank.name}}</td>
                                <th width="50px">有&nbsp;效<br/>日&nbsp;期</th>
                                <td>
                                    <div class="date5">
                                        <span class="m">{{editedItem.bank.effectiveMonth}}</span>月
                                        <span class="y">{{editedItem.bank.effectiveYear}}</span>年
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>卡號</th>
                                <td colspan="3" class="cardNb">{{editedItem.bank.creditCard}}<span class="ps">(請填寫本人正卡資料)</span>
                                </td>
                            </tr>
                        </table><!--blueTable6-->
                    </div><!--blueBox3-->
                    <div class="blueBox blueBox4">
                        <div class="tit">聯絡人資料</div>
                        <span class="titps">(請留一位與您不同居所的親屬，若無住家電話請留兩位聯絡人)</span>
                        <table class="blueTable blueTable7">
                            <tr>
                                <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
                                <td width="110px">{{editedItem.firstContact.name}}</td>
                                <th width="30px">關係</th>
                                <td width="35px" class="text_c">{{editedItem.firstContact.type}}</td>
                                <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
                                <td class="td-phone">
                                    <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                        v-model="editedItem.firstContact.hasCellphone"></span>無
                                    </div>
                                    {{editedItem.firstContact.cellphone}}
                                </td>
                            </tr>
                        </table><!--blueTable7-->
                        <table class="blueTable blueTable8">
                            <tr>
                                <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                                <td width="140px" class="td-phone">
                                    <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                        v-model="editedItem.firstContact.hasHomePhone"></span>無
                                    </div>
                                    {{editedItem.firstContact.homePhone}}
                                </td>
                                <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
                                <td class="td-phone">
                                    <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                        v-model="editedItem.firstContact.hasCompanyPhone"></span>無
                                    </div>
                                    {{editedItem.firstContact.companyPhone}}
                                    <div v-if="editedItem.firstContact.isSecret" :class="`btn-s btn-s3 ${editedItem.firstContact.isSecret ? 'btn-s-active':''}`">
                                        <a href="#" target="_self">保密</a>
                                    </div>
                                </td>
                            </tr>
                        </table><!--blueTable8-->
                        <table class="blueTable blueTable9">
                            <tr>
                                <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
                                <td width="110px">{{editedItem.secondContact.name}}</td>
                                <th width="30px">關係</th>
                                <td width="35px" class="text_c">{{editedItem.secondContact.type}}</td>
                                <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
                                <td class="td-phone">
                                    <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                        v-model="editedItem.secondContact.hasCellphone"></span>無
                                    </div>
                                    {{editedItem.secondContact.cellphone}}
                                </td>
                            </tr>
                        </table><!--blueTable9-->
                        <table class="blueTable blueTable10">
                            <tr>
                                <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                                <td width="140px" class="td-phone">
                                    <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                        v-model="editedItem.secondContact.hasHomePhone"></span>無
                                    </div>
                                    {{editedItem.secondContact.homePhone}}
                                </td>
                                <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
                                <td class="td-phone">
                                    {{editedItem.secondContact.companyPhone}}
                                    <div v-if="editedItem.secondContact.isSecret" :class="`btn-s btn-s4 ${editedItem.secondContact.isSecret ? 'btn-s-active':''}`">
                                        <a href="#" target="_self">保密</a>
                                    </div>
                                </td>
                            </tr>
                        </table><!--blueTable10-->
                    </div><!--blueBox4-->
                </div><!--blueBox2-->
                <div class="redBox">
                    <div class="ps">※以下欄位資料為：
                        <div class="checkDiv">1.<span class="checkbox"><input type="checkbox" disabled
                                                                              v-model="editedItem.hasJointGuarantor[0].value"></span>連帶保證人(需附保證人身分證正反面影本及簽名)
                        </div>
                        <div class="checkDiv">2.<span class="checkbox"><input type="checkbox" disabled
                                                                              v-model="editedItem.hasJointGuarantor[1].value"></span>配偶資料僅供參考
                        </div>
                        <div class="checkDiv">3.<span class="checkbox"><input type="checkbox" disabled
                                                                              v-model="editedItem.hasJointGuarantor[2].value"></span>法定代理人(須於法代欄位簽名)
                        </div>
                        <div class="checkDiv">4.<span class="checkbox"><input type="checkbox" disabled
                                                                              v-model="editedItem.hasJointGuarantor[3].value"></span>商品實際使用人
                        </div>
                    </div>
                    <table class="redTable">
                        <tr>
                            <th width="48px">姓&nbsp;名</th>
                            <td width="160px">{{editedItem.jointGuarantor.name}}</td>
                            <th width="55px">關&nbsp;係</th>
                            <td width="83px">{{editedItem.jointGuarantor.type}}</td>
                            <th width="48px">身分證<br/>字&nbsp;&nbsp;號</th>
                            <td width="153px">{{editedItem.jointGuarantor.memberId}}</td>
                            <th width="48px">出&nbsp;生<br/>日&nbsp;期</th>
                            <td>
                                <div class="date6">
                                    <!--<span>{{editedItem.jointGuarantor.birthday}}</span>-->
                                    <span class="y">{{editedItem.jointGuarantor.birthdayInfo ? editedItem.jointGuarantor.birthdayInfo.year : ''}}</span>年
                                    <span class="m">{{editedItem.jointGuarantor.birthdayInfo ? editedItem.jointGuarantor.birthdayInfo.month : ''}}</span>月
                                    <span class="d">{{editedItem.jointGuarantor.birthdayInfo ? editedItem.jointGuarantor.birthdayInfo.day : ''}}</span>日
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>身分證<br/>初補換</th>
                            <td>
                                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.jointGuarantor.memberIdType[0].value"></span>初發<br/><span
                                        class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.jointGuarantor.memberIdType[1].value"></span>補發<br/><span
                                        class="checkbox"><input type="checkbox" disabled
                                                                v-model="editedItem.jointGuarantor.memberIdType[2].value"></span>換發
                                </div>
                                <div class="date7">
                                    <span class="y">{{editedItem.jointGuarantor.memberIdDateInfo ? editedItem.jointGuarantor.memberIdDateInfo.year :''}}</span>年
                                    <span class="m">{{editedItem.jointGuarantor.memberIdDateInfo ? editedItem.jointGuarantor.memberIdDateInfo.month :''}}</span>月
                                    <span class="d">{{editedItem.jointGuarantor.memberIdDateInfo ? editedItem.jointGuarantor.memberIdDateInfo.day :''}}</span>日
                                </div>
                            </td>
                            <th>發&nbsp;證<br/>地&nbsp;點</th>
                            <td>{{editedItem.jointGuarantor.memberIdCity}}</td>
                            <th>住&nbsp;家<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.jointGuarantor.hasHomePhone"></span>無
                                </div>
                                {{editedItem.jointGuarantor.homePhone}}
                            </td>
                            <th>行&nbsp;動<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.jointGuarantor.hasCellphone"></span>無
                                </div>
                                {{editedItem.jointGuarantor.cellphone}}
                            </td>
                        </tr>
                        <tr>
                            <th>公&nbsp;司<br/>名&nbsp;稱</th>
                            <td colspan="3">{{editedItem.jointGuarantor.companyName}}</td>
                            <th>職&nbsp;稱</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.jointGuarantor.hasTitle"></span>無
                                </div>
                                {{editedItem.jointGuarantor.title}}
                            </td>
                            <th>公&nbsp;司<br/>電&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.jointGuarantor.hasCompanyPhone"></span>無
                                </div>
                                {{editedItem.jointGuarantor.companyPhone}}
                                <span class="ext">分機<span>{{editedItem.jointGuarantor.companySubPhone}}</span></span>
                            </td>
                        </tr>
                    </table><!--redTable-->
                </div><!--redBox-->
                <div class="yBox">
                    <div class="ps">
                        ※以下欄位由經銷商或債權讓與人填寫並經申請人及其連帶保證人確認無誤※此案件為:「
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.caseInfo.type[0].value"></span>新件
                        </div>
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.caseInfo.type[1].value"></span>補保人
                        </div>
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.caseInfo.type[2].value"></span>補資料
                        </div>
                        」「
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.caseInfo.interestRate[0].value"></span>零利率
                        </div>
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.caseInfo.interestRate[1].value"></span>低利率
                        </div>
                        」「
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.caseInfo.category[0].value"></span>ㄧ般件
                        </div>
                        <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                            v-model="editedItem.caseInfo.category[1].value"></span>保密件」</div>

                    </div>
                    <div class="tit">經&nbsp;&nbsp;銷&nbsp;&nbsp;商&nbsp;&nbsp;填&nbsp;&nbsp;寫&nbsp;&nbsp;欄</div>
                    <table class="yTable1">
                        <tr class="yTr">
                            <th width="20px" rowspan="2">分期內容</th>
                            <th width="110px">商品名稱</th>
                            <th width="73px" class="psTh1">頭款<span>(訂金)</span></th>
                            <th width="65px">商品總價</th>
                            <th width="155px" class="psTh2">辦理分期金額<span>(商品總價-已付頭款)</span></th>
                            <th width="45px">期數</th>
                            <th width="130px" class="psTh3">每期應繳金額<span>(期付款)</span></th>
                            <th class="psTh4">分期總額<span>(期數X期付金額)</span></th>
                        </tr>
                        <tr>
                            <td>機車</td>
                            <td>{{editedItem.vendor.deposit === 0 ? '' : editedItem.vendor.deposit}}</td>
                            <td>{{editedItem.vendor.totalPrice === 0 ? '' : editedItem.vendor.totalPrice}}</td>
                            <td>{{editedItem.vendor.creditPrice === 0 ? '' : editedItem.vendor.creditPrice}}</td>
                            <td>{{editedItem.vendor.installmentsNumber}}</td>
                            <td>{{editedItem.vendor.creditPriceMonth === 0 ? '' : editedItem.vendor.creditPriceMonth}}</td>
                            <td>{{editedItem.vendor.totalCreditPrice === 0 ? '' : editedItem.vendor.totalCreditPrice}}</td>
                        </tr>
                    </table><!--yTable1-->
                    <table class="yTable2">
                        <tr>
                            <th width="70px">
                                <span class="th1">經銷商或<br/>債權讓與人名稱<br/>(約定受款方)</span></th>
                            <td width="133px">{{editedItem.vendor.vendorName}}</td>
                            <th width="65px">
                                <span class="th2">經銷商或<br/>債權讓與人<br/>電話</span>
                            </th>
                            <td width="105px" class="td-phone">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" v-model="editedItem.vendor.hasCellphone" disabled=""></span>無電話請打手機聯絡
                                </div>
                                {{editedItem.vendor.cellphone}}
                            </td>
                            <th width="50px">
                                <span class="th3">經銷商或<br/>債權讓與人<br/>傳真</span>
                            </th>
                            <td width="110px" class="td-phone">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.vendor.hasFax"></span>無傳真請電話通知
                                </div>
                                {{editedItem.vendor.fax}}
                            </td>
                            <th rowspan="3" class="sign1">
                                <span class="bg"></span>
                                <span class="txt">(請蓋公司大小章或發票章)</span>
                                <span class="ps">※債權轉讓確認章<br/>※遲延利息及委約金之請求權同意一併讓與受讓人</span>
                            </th>
                        </tr>
                        <tr>
                            <th>經辦店名稱</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.vendor.sameVendor"></span>同經銷商或債權讓與人
                                </div>
                                {{editedItem.vendor.salesName}}
                            </td>
                            <th>經辦店<br/>電&nbsp;&nbsp;話</th>
                            <td class="td-phone">
                                <div class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                                    v-model="editedItem.vendor.hasSalesPhone"></span>無電話請打手機聯絡
                                </div>
                                {{editedItem.vendor.salesPhone}}
                            </td>
                            <th>經辦人<br/>手&nbsp;&nbsp;機</th>
                            <td>{{editedItem.vendor.salesCellphone}}</td>
                        </tr>
                        <tr>
                            <td colspan="6" class="td-phone td-phone2">

                                <div class="checkDiv checkDiv2">
                                    經銷商備註欄：<br/>
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.vendor.type[0].value"></span>熟客&nbsp;
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.vendor.type[1].value"></span>過路客&nbsp;
                                    <span class="checkbox"><input type="checkbox" disabled
                                                                  v-model="editedItem.vendor.type[2].value"></span>指定照會時間：<span
                                        class="m">{{editedItem.vendor.checkTime.month}}</span>月<span class="d">{{editedItem.vendor.checkTime.day}}</span>日<span
                                        class="t"></span>午<span
                                        class="h">{{editedItem.vendor.checkTime.hour}}</span>點<span class="min">{{editedItem.vendor.checkTime.minute}}</span>分
                                </div>
                                <span class="ps2">{{editedItem.vendor.comment}}</span>
                                <div class="sign2">
                                    經辦人簽名
                                    <span class="bg">{{editedItem.vendor.signature}}</span>
                                    <span class="txt">本人證實申請人及連帶保證人身分正確並親自簽章無誤</span>
                                </div>
                            </td>
                        </tr>
                    </table><!--yTable2-->
                </div><!--yBox-->
                <div class="gTit">約定事項</div>
                <div class="gContent">
                    <ul class="gBoxCon" style="margin-top: -80px;">
                        申請人（以下簡稱甲方）及其連帶保證人、經銷商或債權讓與人（以下簡稱乙方）及債權受讓人裕富數位資融（股）公司（以下簡稱裕富公司）三方同意訂定本購物分期付款申請暨約定書（以下簡稱本約定書），<span
                            class="redHighlight">其個別商議及特別授權之約定事項如下：</span><br/>
                        <li>
                            甲方及其連帶保證人同意裕富公司得將甲方及其連帶保證人與裕富公司往來本契約之相關資料（包括但不限於基本資料、信用資料、財務資料等），提供予財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依其設立目的、章程及相關法令規定，蒐集、處理及利用甲方及其連帶保證人之資料，並已暸解及同意裕富公司及財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依個人資料保護法規定所告知之事項。財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依其設立目的、章程及相關法令規定，得將本人資料提供與其參與徵信資料交換及利用之會員、融資租賃業、金融目的事業主管機關及其他依法令得蒐集、處理及利用資料之人。甲方及其連帶保證人確認已受個人資料保護法第三條、第八條及第九條告知且留存本約定書繕本，得憑之主張相關權利。
                        </li>
                        <li>
                            甲方及其連帶保證人同意裕富公司得於履行契約及商品推廣、市場調查、數據分析之目的範圍內，依個人資料保護法相關規定以電腦蒐集、處理、利用甲方及其連帶保證人提供之前述基本資料（不包括財團法人金融聯合徵信中心及中華徵信所企業股份有限公司查詢之信用資料），並向相關之個人、機關、法人等查詢該等資料及往來紀錄，亦同意裕富公司得將前述往來之資料，提供予（一）受讓（或擬受讓）裕富公司債權之債權人，（二）受裕富公司委任代為處理事務之人或與裕富公司有簽約之委外合作廠商，（三）裕富公司之分公司，（四）裕隆汽車製造（股）公司及其相關企業／裕融企業及其關係企業，（五）財團法人金融聯合徵信中心，（六）逾期催收之受託公司（限甲方及其連帶保證人違約時）。但甲方及其連帶保證人得隨時要求停止對其相關資料交互運用。<span
                                class="redHighlight">申請人就本項約定：<div class="checkDiv"><span class="checkbox"><input
                                type="checkbox" v-model="editedItem.agree[0].value" disabled></span>同意</div><div
                                class="checkDiv"><span class="checkbox"><input type="checkbox" disabled
                                                                               v-model="editedItem.agree[1].value"></span>不同意</div>（若未勾選視為不同意）；連帶保證人就本項約定：<div
                                class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                               v-model="editedItem.agree[2].value"
                                                                               disabled></span>同意</div><div
                                class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                               v-model="editedItem.agree[3].value"
                                                                               disabled></span>不同意</div>（若未勾選視為不同意）</span>
                        </li>
                        <li>
                            甲方及其連帶保證人已受說明／告知本約定書重要內容及相關權利義務，並已充分暸解本約定書之重要內容及相關權利義務，且同意乙方或裕富公司得修正本約定書（共二頁）所填資料，並同意申請時所提供之資料及本約定書正本不予退還。
                        </li>
                        <li>甲方及其連帶保證人已攜回本約定書審閱，並經給予五日以上之期間詳閱並充分了解本契約之全部條款後簽訂本約定書。</li>
                        <li>
                            甲方及其連帶保證人於簽約時已充分暸解並同意，乙方將請求支付分期價款之權利及依本約定書約定所得享受之其他一切權利及利益（含延遲利息及違約金）讓與裕富公司，裕富公司並依約付款予乙方或撥入「指示付款同意暨約定書」所指定之帳戶以為收買應收帳款之債權。甲方及其連帶保證人並於裕富公司依約為上述撥付款項時即為知悉債權讓與事實，並應依約繳款予裕富公司。
                        </li>
                        <li>分期價金還款方式與內容：本分期依經銷商填寫欄內容自撥款日次月起每月一期，依年金計法計算，按月平均攤還本息予裕富公司。</li>
                        <li>
                            甲方申辦之機車分期付款業務，車牌號碼：{{editedItem.carInfo.carId}}；甲方同意將前述車輛車牌領牌登記於二等親屬（姓名：{{editedItem.carInfo.name}}、身分證字號：{{editedItem.carInfo.memberId}}、與甲方關係為
                            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                                v-model="editedItem.carInfo.relationship[0].value"
                                                                                disabled></span>本人之父／母
                            </div>
                            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                                v-model="editedItem.carInfo.relationship[1].value"
                                                                                disabled></span>子／女
                            </div>
                            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                                v-model="editedItem.carInfo.relationship[2].value"
                                                                                disabled></span>兄／弟
                            </div>
                            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                                v-model="editedItem.carInfo.relationship[3].value"
                                                                                disabled></span>姊／妹
                            </div>
                            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                                v-model="editedItem.carInfo.relationship[4].value"
                                                                                disabled></span>祖父／母
                            </div>
                            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                                v-model="editedItem.carInfo.relationship[5].value"
                                                                                disabled></span>外祖父／母
                            </div>
                            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                                v-model="editedItem.carInfo.relationship[6].value"
                                                                                disabled></span>孫／孫女／外孫／外孫女
                            </div>
                            ）之名下（並檢附證明），全部分期付款概由甲方負責。
                        </li>
                        <li>
                            甲方及其連帶保證人同意特別授權如下：（一）甲方及其連帶保證人同意裕富公司將款項撥入甲方與乙方所指定之帳戶時，授權裕富公司及其指定人填載本票發票日（即撥款日）及本票金額（即分期總額）、付款地，甲方及其連帶保證人絕無異議。（二）甲方及其連帶保證人倘有違反本約定書任一條款或延遲繳納分期款項時，甲方及其連帶保證人均授權裕富公司及其指定人得不經過通知逕行填載本票到期日，並主張票據權利。(三) 本票供為分期付款買賣之分期款項總項憑證，俟分期付款完全清償完畢時，本票自動失效，但如有一期未付，發票人就全部本票債務負責清償。
                        </li>
                      <li>
                        本債權讓與契約目的係甲方為購買上開商品名稱欄位標的物，並由甲方指示裕富公司將辦理分期金額逕予撥款至甲乙雙方指定帳戶，本債權讓與契約之債權受讓人為「裕富數位資融 ( 股 ) 公司」，客服電話 :(02)6638-7799，相關聯繫
                        資訊，請以裕富公司網站 (https://9797888.yurich.com.tw/)公告為據。
                      </li>
                      <li>
                        乙方如有歇業、停業等無法繼續提供預付型商品或服務時，甲方得檢附催告乙方之存證信函或其他得證明乙方已無法繼續提供服務之證明，向裕富公司申請止付乙方未提供服務部分之分期餘額。但乙方已有提供履約擔保者，不在此限。
                      </li>
                      <li>終止或解除商品或服務契約，本債權讓與契約亦同時終止或解除。惟商品或服務契約之終止或解除，乙方能證明係因可歸責於甲方之事由所致者，裕富公司得逕向甲方收取乙方已提供服務之分期款。
                        <br><span class="redHighlight">※***甲方、甲方之法定代理人及甲方之連帶保證人確認已充分詳閱及了解並同意本約定書及其個別商議及特別授權之約定事項各款內容並確認簽章：</span>
                      </li>
                    </ul><!--gBoxCon-->
                </div><!--約定事項gContent-->
                <div class="signBlue">
                    甲方<span class="s">(申請人)</span><br/>
                    簽&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名
                    <img class="box" v-if="signImageSrc('signImage1')" :src="signImageSrc('signImage1')"/>
                    <span class="box" v-else></span>

                </div>
                <div class="signRed">
                    甲&nbsp;方&nbsp;連&nbsp;帶<br/>
                    保證人簽章
                    <img class="box" v-if="signImageSrc('signImage3')" :src="signImageSrc('signImage3')"/>
                    <span class="box" v-else></span>
                </div>
                <div class="signGreen">
                    甲&nbsp;方&nbsp;法&nbsp;定<br/>
                    代理人簽名
                    <span class="box"></span>
                    <span class="box2"></span>
                </div>
                <div class="dot"><span>(續下頁)</span></div>
                <div class="bottomTit">&#9826本票</div>
                <div class="bottomCon">
                    憑票於中華民國<span class="d1">{{editedItem.promisedNote.promisedDate.year}}</span>年<span class="d1">{{editedItem.promisedNote.promisedDate.month}}</span>月<span
                        class="d1">{{editedItem.promisedNote.promisedDate.day}}</span>日無條件支付裕富數位資融股份有限公司<br/>
                    新台幣<span class="money">{{editedItem.promisedNote.money.one}}</span>拾<span class="money">{{editedItem.promisedNote.money.two}}</span>萬<span
                        class="money">{{editedItem.promisedNote.money.three}}</span>仟<span class="money">{{editedItem.promisedNote.money.four}}</span>佰<span
                        class="money">{{editedItem.promisedNote.money.five}}</span>拾<span class="money">{{editedItem.promisedNote.money.six}}</span>元整<span
                        class="ps3">(本票金額可填大寫或阿拉伯數字，二擇一)</span>
                    <span class="ps1">此本票免除做成拒絕證書及票據法第八十九條之通知義務，利息自到期日迄清償日止按年息百分之十六計付，發票人授權持票人得填載到期日。</span>
                    <br/>
                    付款地：{{editedItem.promisedNote.paymentCity}}<br/>
                    中華民國<span class="d2">{{editedItem.promisedNote.createDate.year}}</span>年<span class="d2">{{editedItem.promisedNote.createDate.month}}</span>月<span
                        class="d2">{{editedItem.promisedNote.createDate.day}}</span>日1.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    <img class="box1" style="border: transparent 1px;" v-if="signImageSrc('signImage2')" :src="signImageSrc('signImage2')"/>
                    <span class="box1" v-else></span>
                    2.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <img class="box2" v-if="signImageSrc('signImage3')" :src="signImageSrc('signImage3')"/>
                    <span class="box2" v-else></span>
                    3.發票人：<span class="box3"></span>
                    <div class="signAll">法定代理人：<span class="box4"></span><span class="box5"></span></div>
                    <span class="ps2">「此本票供為分期付款買賣之分期款項總項憑證，俟分期付款完全清償完畢時，此本票自動失效，但如有一期未付，發票人就全部本票債務負責清償」</span>

                </div><!--bottomCon-->
            </div><!--page2-->

        </div><!--wrapper-->

        <v-app v-if="editedItem.imageList && editedItem.imageList.length">
            <div class="photo_page_wrapper" v-if="editedItem.imageList">
                <div class="page">
                    <v-layout md12 row wrap>
                        <v-flex md6 mt-2  v-for="(image, i) in getImageList" :key="i"><div class="box" ><img  :src="image.data"></div></v-flex>
                    </v-layout>
                    <!--<div class="nb mt-2">業務姓名：{{editedItem.parentAgent.displayName}}<br/>業務電話：{{editedItem.parentAgent.cellphone}}</div>-->
                </div><!--page-->
            </div><!--wrapper-->

            <div class="photo_page_wrapper" v-if="editedItem.imageList && editedItem.imageList.length >= 6">
                <div class="page">
                    <v-layout md12 row wrap>
                        <v-flex md6 mt-2  v-for="(image, i) in getImageList2"
                                :key="i"><div class="box" ><img :src="image.data"></div></v-flex>
                    </v-layout>
                    <!--<div class="nb mt-2">業務姓名：{{editedItem.parentAgent.displayName}}<br/>業務電話：{{editedItem.parentAgent.cellphone}}</div>-->
                </div><!--page-->
            </div><!--wrapper-->

            <div class="photo_page_wrapper" v-if="editedItem.imageList && editedItem.imageList.length > 12">
                <div class="page">
                    <v-layout md12 row wrap>
                        <v-flex md6 mt-2  v-for="(image, i) in getImageList3"
                                :key="i"><div class="box" ><img  :src="image.data"></div></v-flex>
                    </v-layout>
                    <!--<div class="nb mt-2">業務姓名：{{editedItem.parentAgent.displayName}}<br/>業務電話：{{editedItem.parentAgent.cellphone}}</div>-->
                </div><!--page-->
            </div><!--wrapper-->
        </v-app>
    </div>
    <div v-if="isEdit">
      <v-app>
          <v-card>
            <v-card-text>
            <v-layout row wrap>※以下欄位資料為：</v-layout>
            <v-layout row wrap>
              <v-flex xs3>
                <v-checkbox
                  v-model="editedItem.hasJointGuarantor[0].value"
                  label="1.連帶保證人(需附保證人身分證正反面影本及簽名)"
                ></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="editedItem.hasJointGuarantor[1].value" label="2.配偶資料僅供參考"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="editedItem.hasJointGuarantor[2].value" label="3.法定代理人(須於法代欄位簽名)"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox v-model="editedItem.hasJointGuarantor[3].value" label="4.商品實際使用人"></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex pt-4 xs2>
                <v-text-field v-model="editedItem.jointGuarantor.name"
                              background-color='#ea4f90'
                              outline
                              label="姓名"></v-text-field>
              </v-flex>
              <v-flex pt-4 xs2>
                <v-text-field v-model="editedItem.jointGuarantor.type"
                              background-color='#ea4f90'
                              outline
                              label="關係"></v-text-field>
              </v-flex>
              <v-flex pt-4 xs2>
                <v-text-field v-model="editedItem.jointGuarantor.memberId"
                              background-color='#ea4f90'
                              outline
                              label="身分證字號"></v-text-field>
              </v-flex>
              <v-flex ml-2 xs5 >
                <span>出生日期</span>
                <date-time-tool
                  :date-info="editedItem.jointGuarantor.birthdayInfo"
                  :background-color="`#ea4f90`"
                  @handleDateChange="jointGuarantorDateChange"></date-time-tool>
                <!-- <v-text-field v-model="editedItem.jointGuarantor.birthday"
                @click="showDateToolDialog('jointGuarantor.birthday')" label="生日"></v-text-field> -->
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs3>
                <v-layout row wrap>
                  <v-flex xs4>
                    <v-checkbox v-model="editedItem.jointGuarantor.memberIdType[0].value" label="初發"></v-checkbox>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox v-model="editedItem.jointGuarantor.memberIdType[1].value" label="補發"></v-checkbox>
                  </v-flex>
                  <v-flex xs4>
                    <v-checkbox v-model="editedItem.jointGuarantor.memberIdType[2].value" label="換發"></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field v-model="editedItem.jointGuarantor.memberIdDate"
                                  background-color='#ea4f90'
                                  outline
                                  label="身分證初補換"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3>
                <v-text-field v-model="editedItem.jointGuarantor.memberIdCity"
                              background-color='#ea4f90'
                              outline
                              label="發證地點"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="editedItem.jointGuarantor.hasHomePhone"
                      :checked="editedItem.jointGuarantor.hasHomePhone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.homePhone"
                      :disabled="editedItem.jointGuarantor.hasHomePhone"
                      outline
                      label="住家電話"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3>
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="editedItem.jointGuarantor.hasCellphone"
                      :checked="editedItem.jointGuarantor.hasCellphone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.cellphone"
                      :disabled="editedItem.jointGuarantor.hasCellphone"
                      outline
                      label="行動電話"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-text-field v-model="editedItem.jointGuarantor.companyName"
                              background-color='#ea4f90'
                              outline
                              label="公司名稱"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="editedItem.jointGuarantor.hasTitle"
                      :checked="editedItem.jointGuarantor.hasTitle"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.title"
                      :disabled="editedItem.jointGuarantor.hasTitle"
                      outline
                      label="職稱"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3>
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="editedItem.jointGuarantor.hasCompanyPhone"
                      :checked="editedItem.jointGuarantor.hasCompanyPhone"
                      label="無"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.companyPhone"
                      :disabled="editedItem.jointGuarantor.hasCompanyPhone"
                      outline
                      label="公司電話"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      background-color='#ea4f90'
                      v-model="editedItem.jointGuarantor.companySubPhone"
                      :disabled="editedItem.jointGuarantor.hasCompanyPhone"
                      outline
                      label="分機"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <span class="mr-2 subheading red--text" v-if="saveLoading">案件上傳中 請勿關閉視窗</span>
              <v-btn class="primary center" dark text :loading="saveLoading" @click="save">確認上傳</v-btn>
            </v-card-actions>
          </v-card>
      </v-app>
    </div>
    <div v-else style="margin:0 auto; display:flex; align-items:center; justify-content:center;">
      <v-btn v-if="showButton" color="primary" dark text @click="confirmEvent">列印PDF檔</v-btn>
    </div>
    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.content"
                :show-cancel="messageDialog.showCancel"
                @confirmEvent="messageDialog.confirm"
                @cancelEvent="messageDialog.cancel"></alert-view>
  </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApplicationModel from '../../models/ApplicationModel';
import dateTimeTool from "@/components/dateTimeTool";
import AlertView from "../../components/AlertView";
import { getNow } from '@/pages/utils/tool';
import axios from "axios";
import common from '../../mixins/common'

export default {
  name: "InstallmentProductView",
  props: {
    item: Object,
    isEdit: Boolean,
  },
  components: { dateTimeTool, AlertView},
  data() {
    return {
      // item: null,
      createDate: "",
      saveLoading: false,
      messageDialog: {
        title: "",
        content: "",
        visible: false,
        showCancel: false,
        confirm: () => {},
        cancel: () => {}
      },
      copyItem:null,
      checkedImage: require('../../assets/images/checked.png'),
      showButton: true,
    };
  },
  created() {
    // console.log(`InstallmentProductView ${this.editedItem.imageList.length}`);
    // console.log(`InstallmentProductView1 ${this.getImageList.length}`);
    // console.log(`InstallmentProductView2 ${this.getImageList2.length}`);
    // console.log(`InstallmentProductView3 ${this.getImageList3.length}`);
    setTimeout(() => {
      if (this.editedItem) {
        this.fetchAgentInfo({
          agentId: this.editedItem.parentAgent.agentId,
        }).then((result) => {
          if (result) {
            this.$set(
              this.editedItem.parentAgent,
              "cellphone",
              result[0].cellphone
            );
          }
        });
      }
    }, 1000);
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    editedItem() {
      // const model = new ApplicationModel();
      // // if(!this.item.imageList) {
      // //   this.item.imageList = [];
      // // }

      // if(!this.item.hasJointGuarantor) {
      //   this.item.hasJointGuarantor = model.hasJointGuarantor;
      // }
      // if(!this.item.jointGuarantor) {
      //   this.item.jointGuarantor = model.jointGuarantor;
      // }
      console.log(`editedItem === ${JSON.stringify(this.item)}`);
      if(this.item && !this.copyItem) {
        this.copyItem = JSON.parse(JSON.stringify(this.item));
        console.log(`copyItem === ${JSON.stringify(this.copyItem)}`);
      }
      return this.item;
    },
    getImageList() {
      let list = [];
      this.editedItem.imageList.forEach((item, i) => {
        if (i < 6) {
          list.push(item);
        }
      });
      return list;
    },
    getImageList2() {
      let list = [];
      this.editedItem.imageList.forEach((item, i) => {
        if (i >= 6 && i < 12) {
          list.push(item);
        }
      });
      return list;
    },
    getImageList3() {
      let list = [];
      this.editedItem.imageList.forEach((item, i) => {
        if (i >= 12) {
          list.push(item);
        }
      });
      return list;
    },
    checkMemberIdCityNumberType() {
      if(this.editedItem) {
        const parsed = parseInt(this.editedItem.customer.memberIdCity, 10);
        return !isNaN(parsed)
      } else {
        return false;
      }
    }
  },
  mixins:[common],
  methods: {
    ...mapActions(["fetchFinanceCreditInfo", "fetchAgentInfo", "saveFinanceOfficialData", "uploadImageData", "saveFinanceInfo", "saveFinanceSignImage"]),
    signImageSrc(itemPath) {
      let source = "";
      if (itemPath === "signImage1") {
        if (this.editedItem.signImage1) {
          source = this.editedItem.signImage1;
        } else if (this.editedItem.signimage1Url) {
          source = this.editedItem.signimage1Url;
        }
      } else if (itemPath === "signImage2") {
        if (this.editedItem.signImage2) {
          source = this.editedItem.signImage2;
        } else if (this.editedItem.signimage2Url) {
          source = this.editedItem.signimage2Url;
        }
      } else if (itemPath === "signImage3") {
        if (this.editedItem.signImage3) {
          source = this.editedItem.signImage3;
        } else if (this.editedItem.signimage3Url) {
          source = this.editedItem.signimage3Url;
        }
      }
      return source;
    },
    getCaseProduct(item) {
      if (item.productId === "0") {
        return "機車原融";
      }
      if (item.productId === "1") {
        return "借新還舊";
      }
      if (item.productId === "2") {
        return "他行代償";
      }
      return "機車原融";
    },
    getMemberIdCity(value) {
      console.log(`getMemberIdCity ${value}`)
      const memberIdCitylist = this.getMemberIdCityList.filter(m=>m.key === value);
      if (memberIdCitylist.length > 0 ) {
        return memberIdCitylist[0].value;
      }
      return ""
    },
    confirmEvent() {
      // const node = this.$refs.wrapper;
      // this.$emit("ConvertPdfEvent", [node]);
      this.showButton = false;
      const self = this;
      window.onafterprint = function () {
        console.log(`onafterprint`)
        self.showButton = true;
        self.$forceUpdate();
      }
      setTimeout(()=>{
        window.print();
      }, 1000)
    },

     async save() {
      // console.log(`save === ${JSON.stringify(item)}`);
      const isSuccess = await this.saveItem(this.editedItem);
      this.loading = false;
      if (!isSuccess) {
        return;
      }
      const copySignImage = {
        caseId: this.editedItem.caseId,
        signImage0: this.editedItem.signImage0,
        signImage1: this.editedItem.signImage1,
        signImage2: this.editedItem.signImage2,
        signImage3: this.editedItem.signImage3,
      };

      delete this.editedItem.signImage0;
      delete this.editedItem.signImage1;
      delete this.editedItem.signImage2;
      delete this.editedItem.signImage3;

      this.loadingText = "儲存中...";
      const api =
        "https://us-central1-chiahao-92b7e.cloudfunctions.net/saveFinanceUserInfo";
      axios({
        method: "post",
        url: api,
        data: this.editedItem,
        timeout: 20 * 1000,
      })
        .then(async (response) => {
          // console.log(`result = ${JSON.stringify(response.data)}`);
          const result = response.data;
          if (result.code === 200) {
            const result = await this.saveFinanceSignImage(copySignImage);

            this.editedItem.signImage0 = copySignImage.signImage0;
            this.editedItem.signImage1 = copySignImage.signImage1;
            this.editedItem.signImage2 = copySignImage.signImage2;
            this.editedItem.signImage3 = copySignImage.signImage3;

            this.loading = false;
            this.isSaveSuccess = true;
            console.log(`update signImage = ${JSON.stringify(result)}`);
            this.messageDialog.showCancel = false;
            this.showMessageDialog(
              "更新保人成功",
              "請申辦人三個小時之內，注意接聽照會電話。另請上傳附加圖片檔！",
              true,
              () => {},
              () => {}
            );
          } else {
            this.loading = false;
            this.search.message = "查無資料！";
            this.messageDialog.showCancel = true;
            this.showMessageDialog(
              "提示",
              `儲存失敗！${JSON.stringify(result)}，請聯繫資訊人員。`,
              true,
              () => {},
              () => {}
            );
          }
        })
        .catch((error) => {
          this.loading = false;
          this.messageDialog.showCancel = true;
          this.showMessageDialog(
            "發生錯誤",
            `儲存失敗！${error.message}，請聯繫資訊人員。`,
            true,
            () => {},
            () => {}
          );
        });
    },
    async saveItem(item) {
      const editIndex = parseInt(this.$route.query.editIndex, 10);

      if (editIndex === -1) {
        if (!this.agent) {
          this.showMessageDialog(
            "發生錯誤",
            `查無經銷帳號，請確認網址是否有誤或聯繫客服人員。`,
            true,
            () => {},
            () => {}
          );
          return;
        }
        item.parentAgent = {
          agentId: this.agent.agentId
            ? this.agent.agentId
            : "Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2",
          agentNumber: this.agent.agentNumber
            ? this.agent.agentNumber
            : "000000",
          displayName: this.agent.displayName
            ? this.agent.displayName
            : "總公司",
          parentAgent: {
            agentId: this.agent.parentAgent
              ? this.agent.parentAgent.agentId
              : "Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2",
            rootAgent: "Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2",
          },
          salesName: this.agent.salesName ? this.agent.salesName : "總公司",
        };
      }

      // console.log(`agent  === ${JSON.stringify(this.agent)}`);
      // console.log(`save === ${JSON.stringify(item)}`);
      item.updateDate = getNow();
      this.loading = true;

      try {
        const copy = JSON.parse(JSON.stringify(item));
        let signList = [
          copy.signImage0,
          copy.signImage1,
          copy.signImage2,
          copy.signImage3,
        ];
        let i = 0;
        for (let image of signList) {
          if (image && image !== "") {
            //儲存簽名
            const urlPath = await this.uploadImageData({
              name: Math.uuidFast(),
              image: image,
            });

            switch (i) {
              case 0:
                copy.signImage0Url = urlPath;
                break;
              case 1:
                copy.signImage1Url = urlPath;
                break;
              case 2:
                copy.signImage2Url = urlPath;
                break;
              case 3:
                copy.signImage3Url = urlPath;
                break;
            }
          }
          i += 1;
        }

        const token = this.syncToken;
        console.log(`sync to mysql == ${token}`);
        copy.token = token;
        delete copy.signImage0;
        delete copy.signImage1;
        delete copy.signImage2;
        delete copy.signImage3;
        if(this.copyItem.jointGuarantor.name &&
        this.copyItem.jointGuarantor.name.length > 0 &&
        this.copyItem.jointGuarantor.name != copy.jointGuarantor.name) {
          copy.caseId = Math.uuidFast();
        }
        await this.saveFinanceInfo(copy);
        return true;
      } catch (e) {
        this.showMessageDialog(
          "提示",
          `儲存失敗！${e}，請聯繫資訊人員。`,
          true,
          () => {},
          () => {}
        );
        return false;
      }
    },
    checkFormData() {
      if (!this.editedItem.jointGuarantor.name || this.editedItem.jointGuarantor.name !== "") {
        let hasCheck = false;
        this.editedItem.hasJointGuarantor.forEach((item) => {
          if (item.value === true) {
            hasCheck = true;
          }
        });
        if (!hasCheck) {
          this.showMessageDialog(
            "錯誤",
            "請勾選保證人的選項！",
            true,
            () => {},
            () => {}
          );
          return false;
        }
      }

      if (!this.editedItem.jointGuarantor.name || this.editedItem.jointGuarantor.name === "") {
        this.showMessageDialog(
            "錯誤",
            "請填寫保證人的姓名！",
            true,
            () => {},
            () => {}
          );
          return false;
      }

      if (!this.editedItem.jointGuarantor.memberId || this.editedItem.jointGuarantor.memberId === "") {
        this.showMessageDialog(
            "錯誤",
            "請填寫保證人的身分證字號！",
            true,
            () => {},
            () => {}
          );
          return false;
      }

      return true;
    },
    jointGuarantorDateChange(dateValue){
      this.editedItem.jointGuarantor.birthday = dateValue;
      console.log(JSON.stringify(this.editedItem.jointGuarantor));
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.content = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  },
};
</script>

<style scoped src="../../assets/css/installment_product_view.css">
</style>


<style scoped>
table.leftBox td,
.blueBox1 .date .y,
.blueBox1 .date .m,
.blueBox1 .date .d,
table.blueTable td,
.blueBox3 .others,
table.blueTable5 .date4 .y,
table.blueTable5 .date4 .m,
table.blueTable6 .date5 .y,
table.blueTable6 .date5 .m,
table.redTable td,
table.redTable .date7 .y,
table.redTable .date7 .m,
table.redTable .date7 .d,
table.redTable td.td-phone .ext span,
table.yTable1 td,
table.yTable2 td,
table.yTable2 td.td-phone2 .sign2 span.bg,
table.yTable2 td.td-phone2 .checkDiv2 .m,
table.yTable2 td.td-phone2 .checkDiv2 .d,
table.yTable2 td.td-phone2 .checkDiv2 .t,
table.yTable2 td.td-phone2 .checkDiv2 .h,
table.yTable2 td.td-phone2 .checkDiv2 .min,
.gContent span.txtBox,
.bottomCon .d1,
.bottomCon .money,
.bottomCon .d2 {
  color: #0505da;
}

table.blueTable5 .date4,
table.blueTable6 .date5,
table.redTable .date7,
table.redTable td.td-phone .ext,
table.yTable2 td.td-phone2 .sign2,
div.checkDiv {
  color: #000;
}
.center {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/InstallmentProductView.vue